import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { id } from 'date-fns/locale';

export function PODownPaymentDialog({ dpAmount, dpLoading, dpPO, handleCreateDP, setDpAmount, setShowDPDialog, showDPDialog }) {
  return (
    <Dialog open={showDPDialog} onOpenChange={setShowDPDialog}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Buat Down Payment (DP)</DialogTitle>
        </DialogHeader>
        {dpPO && (
          <div className="space-y-4">
            <div className="bg-amber-50 p-3 rounded-lg text-sm border border-amber-200">
              <p><strong>No. PO:</strong> {dpPO.po_number}</p>
              <p><strong>Supplier:</strong> {dpPO.supplier_name}</p>
              <p><strong>Company:</strong> {dpPO.company_name}</p>
              <p><strong>Total PO:</strong> <span className="font-mono font-bold">Rp {(dpPO.total_amount || 0).toLocaleString('id-ID')}</span></p>
            </div>
            <div className="space-y-2">
              <Label>No. DP</Label>
              <Input value={`DP-${dpPO.po_number}`} disabled className="bg-slate-100 font-mono" />
            </div>
            <div className="space-y-2">
              <Label>Nilai DP (Rp) *</Label>
              <Input
                type="number"
                value={dpAmount}
                onChange={(e) => setDpAmount(e.target.value)}
                placeholder="Masukkan nilai DP"
                className="font-mono"
                min="0"
                max={dpPO.total_amount}
                data-testid="dp-amount-input"
              />
              {dpAmount && (
                <p className="text-xs text-slate-500">
                  Sisa invoice setelah DP: <span className="font-mono font-semibold">Rp {((dpPO.total_amount || 0) - (parseFloat(dpAmount) || 0)).toLocaleString('id-ID')}</span>
                </p>
              )}
            </div>
            <div className="flex gap-2 justify-end">
              <Button variant="outline" onClick={() => setShowDPDialog(false)}>Batal</Button>
              <Button
                className="bg-amber-600 hover:bg-amber-700"
                onClick={handleCreateDP}
                disabled={dpLoading || !dpAmount || parseFloat(dpAmount) <= 0 || parseFloat(dpAmount) > dpPO.total_amount}
                data-testid="dp-submit-btn"
              >
                {dpLoading ? 'Memproses...' : 'Buat DP & Submit ke Approval'}
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
